<template>
    <layouts-header></layouts-header>

    <breadcrumb :title="title" :text="text" :text1="text1" />


    <!-- Page Content -->
		<div class="content court-bg">
			<div class="container">
				<div class="row">
					<div class="col-lg-12">
						<div class="my-profile-box">
							<h3>My Profile</h3>
							<div class="card profile-user-view">
								<div class="profile-groups">
									<div class="profile-detail-box">
										<div class="profile-img">
											<img class="rounded-circle" src="@/assets/img/profiles/avatar-01.jpg" alt="User">
										</div>
										<div class="user-profile-detail">
											<h4>Henriques</h4>
											<p>Dreamsports Badminton Since 05/05/2023</p>
											<ul>
												<li><img  src="@/assets/img/icons/profile-icon-01.svg" alt="Icon">Rank : Expert</li>
												<li><img  src="@/assets/img/icons/profile-icon-02.svg" alt="Icon">Santamanica, United States</li>
											</ul>
										</div>
									</div>
									<div class="convenient-btns">
										<router-link to="/coaches/coach-profile" class="btn btn-secondary d-inline-flex align-items-center">
											<span><i class="feather-edit"></i></span>Edit Profile
										</router-link>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="col-lg-4">
						<div class="card profile-user-view">
							<div class="appointment-detail">
								<h4>Appointment Details</h4>
								<a href="javascript:;">Edit</a>
							</div>
							<div class="appointment-available">
								<div class="amount-hour">
									<h6>Amount </h6>
									<h4>$250<span>/hr</span></h4>
								</div>
							</div>
							<div class="appointment-available profile-availability">
								<h6>Availability</h6>
								<ul class="day-list">
									<li>
										<div class="day-selection">
											<input type="checkbox" value="attach_link" id="select_days_1" name="day" checked>
											<label for="select_days_1">
												Mon
											</label>
										</div>
									</li>
									<li>
										<div class="day-selection">
											<input type="checkbox" value="attach_link" id="select_days_2" name="day">
											<label for="select_days_2">
												Tues
											</label>
										</div>
									</li>
									<li>
										<div class="day-selection">
											<input type="checkbox" value="attach_link" id="select_days_3" name="day">
											<label for="select_days_3">
												Wed
											</label>
										</div>
									</li>
									<li>
										<div class="day-selection">
											<input type="checkbox" value="attach_link" id="select_days_4" name="day">
											<label for="select_days_4">
												Thur
											</label>
										</div>
									</li>
									<li>
										<div class="day-selection">
											<input type="checkbox" value="attach_link" id="select_days_5" name="day">
											<label for="select_days_5">
												Fri
											</label>
										</div>
									</li>
									<li>
										<div class="day-selection">
											<input type="checkbox" value="attach_link" id="select_days_6" name="day">
											<label for="select_days_6">
												Sat
											</label>
										</div>
									</li>
									<li>
										<div class="day-selection ">
											<input type="checkbox" value="attach_link" id="select_days_7" name="day">
											<label class="mb-0" for="select_days_7">
												Sun
											</label>
										</div>
									</li>
								</ul>
							</div>
							<div class="appointment-available">
								<h6>Lesson Type </h6>
								<ul class="lesson-type">
									<li><i class="feather-check-square"></i>Single Lesson</li>
									<li><i class="feather-check-square"></i>2 Player Lesson</li>
									<li><i class="feather-check-square"></i>Small group Lesson</li>
								</ul>
							</div>
						</div>
					</div>
					<div class="col-lg-8">
						<div class="card profile-user-view mb-0">
							<div class="profile-info-box">
								<h4>Contact  Information</h4>
								<div class="profile-contact-info">
									<div class="contact-information">
										<h6>Email Address</h6>
										<span>contact@example.com</span>
									</div>
									<div class="contact-information">
										<h6>Phone Number</h6>
										<span>+1 56565 556558</span>
									</div>
									<div class="contact-information">
										<h6>Address</h6>
										<span>1653 Davisson Street,Indianapolis, IN 46225</span>
									</div>
								</div>
							</div>
							<div class="profile-info-box">
								<h4>Short Bio</h4>
								<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Varius consectetur a at est diam ultricies. Egestas eros leo dapibus tellus neque turpis. Nec in morbi adipiscing pretium accumsan urna ac,Lorem ipsum dolor sit amet, consectetur adipiscing elit. Varius consectetur a at est diam ultricies. Egestas eros leo dapibus tellus neque turpis. Nec in morbi adipiscing pretium accumsan urna ac,Lorem ipsum dolor sit amet, consectetur adipiscing elit. Varius consectetur a at est diam ultricies. Egestas eros leo dapibus tellus neque turpis. Nec in morbi adipiscing pretium accumsan urna ac,</p>
							</div>
							<div class="profile-info-box">
								<h4>Lesson With Me</h4>
								<p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum</p>
							</div>
							<div class="profile-info-box">
								<h4>Coaching</h4>
								<p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum</p>
							</div>
							<div class="profile-info-box">
								<h4>Gallery</h4>
								<ul class="review-gallery clearfix">
									<li>
										<a href="@/assets/img/booking/booking-01.jpg" data-fancybox="gallery">
											<img class="img-fluid" alt="Image" src="@/assets/img/booking/booking-01.jpg">
										  </a>
									</li>
									<li>
										<a href="@/assets/img/booking/booking-02.jpg" data-fancybox="gallery">
											<img class="img-fluid" alt="Image" src="@/assets/img/booking/booking-02.jpg">
										  </a>
									</li>
									<li>
										<a href="@/assets/img/booking/booking-03.jpg" data-fancybox="gallery">
											<img class="img-fluid" alt="Image" src="@/assets/img/booking/booking-03.jpg">
										  </a>
									</li>
								</ul>
							</div>
							<div class="profile-info-box">
								<h4>Video</h4>
								<div class="badminton-img">
									<iframe  height="315" src="https://www.youtube.com/embed/DTq53SuQ_eo" title="video player"  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- /Page Content -->

    <layout-footer></layout-footer>
</template>

<script>
export default {
    data() {
        return {
            title: "Profile",
            text: "Home",
            text1: "Profile",
        };
    },
};
</script>